/**
 * Terminals marked [data-type-on-view] type their lines the first time
 * they come into view.
 *
 * @module motion/terminals
 */

import { REDUCED_MOTION } from '../config.js';
import { $$ } from '../lib/dom.js';
import { gsap } from '../lib/gsap.js';

export function animateTerminals() {
    if (REDUCED_MOTION) {
        return;
    }

    $$('[data-type-on-view]').forEach((terminal) => {
        gsap.from(terminal.querySelectorAll('[data-terminal-body] > span'), {
            opacity: 0,
            duration: 0.05,
            stagger: 0.09,
            ease: 'none',
            scrollTrigger: { trigger: terminal, start: 'top 82%', once: true },
        });
    });
}
